<div class="receipt-viewport">
  @let o = order();
  @let currency = o.currency;
  <article #sheet class="receipt-sheet" data-testid="order-receipt-sheet" [style.width.cm]="widthCm()">
    @if (watermark() === 'copy') {
      <div class="receipt-watermark" data-testid="order-receipt-watermark-copy" i18n>Kopie</div>
    }
    @if (watermark() === 'test') {
      <div class="receipt-watermark" data-testid="order-receipt-watermark-test" i18n>Testdruck</div>
    }

    <header class="receipt-block receipt-center">
      <div class="receipt-strong">{{ sellerName() }}</div>
      @if (o.creatorCustomerStreet) {
        <div>{{ o.creatorCustomerStreet }}</div>
      }
      <div>{{ o.creatorCustomerZIP }} {{ o.creatorCustomerCity }}</div>
      @if (o.creatorCustomerPhone) {
        <div i18n="@@orderReceipt.phone">Tel. {{ o.creatorCustomerPhone }}</div>
      }
      @if (o.creatorCustomerEmail) {
        <div>{{ o.creatorCustomerEmail }}</div>
      }
    </header>

    <div class="receipt-title receipt-center" i18n="@@orderReceipt.title">Bestellbeleg</div>

    <div class="receipt-block">
      <div class="receipt-row">
        <span i18n>Bestellnummer</span>
        <span>{{ o.orderNumber }}</span>
      </div>
      <div class="receipt-row">
        <span i18n="@@orderReceipt.date">Datum</span>
        <span>{{ o.orderDateTime | date: 'short' }}</span>
      </div>
    </div>

    <div class="receipt-block">
      <div class="receipt-row">
        <span i18n>Kundennummer</span>
        <span>{{ o.buyerCustomerNumber }}</span>
      </div>
      <div>{{ buyerName() }}</div>
      @if (o.buyerCustomerStreet) {
        <div>{{ o.buyerCustomerStreet }}</div>
      }
      @if (o.buyerCustomerZip || o.buyerCustomerCity) {
        <div>{{ o.buyerCustomerZip }} {{ o.buyerCustomerCity }}</div>
      }
    </div>

    <ol class="receipt-block receipt-lines">
      @for (p of positions(); track p.positionNumber) {
        <li class="receipt-line" data-testid="order-receipt-line">
          <div class="receipt-row receipt-row-top">
            <span class="receipt-position">{{ p.positionNumber }}</span>
            <span class="receipt-article">{{ p.skuName1 }}</span>
          </div>
          <div class="receipt-row receipt-indent">
            <span>{{ p.quantity | number }} × {{ p.unitGrossPrice | currency: currency }}</span>
            <span>{{ p.grossPrice | currency: currency }}</span>
          </div>
        </li>
      }
    </ol>

    @let t = totals();
    <div class="receipt-block">
      <div class="receipt-row">
        <span i18n="@@orderReceipt.netAmount">Nettobetrag</span>
        <span data-testid="order-receipt-net">{{ t.net | currency: currency }}</span>
      </div>
      @for (vat of t.vat; track vat.rate) {
        <div class="receipt-row" data-testid="order-receipt-vat-line">
          <span i18n="@@orderReceipt.vatRate">MwSt. {{ vat.rate | number: '1.0-2' }} %</span>
          <span>{{ vat.amount | currency: currency }}</span>
        </div>
      }
      <div class="receipt-row receipt-total">
        <span i18n="@@orderReceipt.grossAmount">Bruttobetrag</span>
        <span data-testid="order-receipt-gross">{{ t.gross | currency: currency }}</span>
      </div>
      @if (t.discount) {
        <div class="receipt-row">
          <span i18n="@@orderReceipt.discountIncluded">darin Rabatt</span>
          <span data-testid="order-receipt-discount">{{ t.discount | currency: currency }}</span>
        </div>
      }
    </div>

    <div class="receipt-center" i18n>Vielen Dank für Ihren Einkauf!</div>
  </article>
</div>
